import {
  useCallback, useEffect, useMemo, useState,
} from 'react';
import { Row, Col } from 'reactstrap';

import CustomModal, { ICustomModal } from '@shared/components/modal/CustomModal';
import useTranslation from '@shared/hooks/useTranslation';
import {
  ForgotPassIllustrationIcon,
} from '@shared/icons';

import ChangePasswordContent from './modal-contents/ChangePasswordContent';
import ForgotPasswordContent from './modal-contents/ForgotPasswordContent';
import PasswordChangedContent from './modal-contents/PasswordChangedContent';
import VerifyCodeContent from './modal-contents/VerifyCodeContent';

import './ForgotPasswordModal.scss';

const ForgotPasswordModal = (props: ICustomModal) => {
  // const i18n = useTranslation('general');
  const i18nForgotPassword = useTranslation('forgotPassword');
  const i18nVerification = useTranslation('verification');
  const { open, toggle } = props;
  const [ step, setStep ] = useState(0);
  const handleNextScreen = useCallback(() => setStep(prev => (
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    prev + 1 > content.length - 1 ? content.length - 1 : prev + 1)),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [ ]);
  const handlePrevScreen = useCallback(() => setStep(prev => (prev - 1 < 0 ? 0 : prev - 1)), [ ]);

  const content: Array<Omit<ICustomModal, 'modalProps' | 'open' | 'toggle'>> = useMemo(() => (
    [
      {
        title: i18nForgotPassword.title,
        children: <ForgotPasswordContent onNext={handleNextScreen} onToggle={toggle} />,
        noHeader: true,
        noFooter: true,
      },
      {
        title: i18nVerification.title,
        children: <VerifyCodeContent
          onNext={handleNextScreen}
          onBack={handlePrevScreen}
          onToggle={toggle}
        />,
        noHeader: true,
        noFooter: true,
      },
      {
        title: i18nForgotPassword.change_password.title,
        children: <ChangePasswordContent
          onNext={handleNextScreen}
          onBack={handlePrevScreen}
          onToggle={toggle}
        />,
        noHeader: true,
        noFooter: true,
      },
      {
        title: i18nForgotPassword.password_changed.title,
        children: <PasswordChangedContent onToggle={toggle} />,
        noHeader: true,
        noFooter: true,
      },
    ]
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ), [ handleNextScreen, handlePrevScreen ]);

  useEffect(() => () => {
    // reset step if succeeded
    if (open && step === content.length - 1) setStep(0);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ open, step ]);

  return (
    <CustomModal
      {...props}
      title={content[step].title}
      noHeader={content[step].noHeader}
      noFooter={content[step].noFooter}
      modalProps={{ centered: true, id: 'forgot-password-modal', className: 'modal-lg' }}
      content={content[step].content}
    >
      <Row>
        <Col lg={6} className="illustration-container">
          <ForgotPassIllustrationIcon />
        </Col>
        <Col lg={6}>
          {content[step] && content[step].children ? content[step].children : null}
        </Col>
      </Row>
    </CustomModal>
  );
};

export default ForgotPasswordModal;
